import { Injectable } from '@angular/core';
import { ImageUploadService } from '../../services/files/img-upload.service';
import { User } from '../../models/user.model';
import { ImageGestion } from './classes/img-gestion';
import { GlobalRequest } from '../../services/global/presenter/global.request';
import { GlobalPresenter } from '../../services/global/presenter/global.presenter';
import { ToastrService } from 'ngx-toastr';


@Injectable({providedIn:'root'})
export class ImgGestion extends ImageGestion {

userUpdate: GlobalRequest;

constructor(private toastr: ToastrService,
            private imageUploadService: ImageUploadService,
            private globalPresenter: GlobalPresenter) {
  super();
this.userUpdate = globalPresenter;
}



cambiarImagen(file: File) {

  this.imagenSubir = file;


  if ( !file ) {
     return this.imgTemp = null;
     }

  const reader = new FileReader();
  reader.readAsDataURL( file );

  reader.onloadend = () => {
    this.imgTemp = reader.result;
  };

}

subirImagenUsuario(usuario: User) {
  this.imageUploadService.updateImage( this.imagenSubir, 'users', usuario.uid)
                         .then(img => {
                          usuario.img = img;
                          this.userUpdate.setUser(usuario);
                          this.toastr.success('Updated User Image');
                        }).catch(err => this.toastr.error('Unable to upload the image'));

}


}
